// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__IUrQX","title":"styles_title__Apyj2","content":"styles_content__OVJJW","footer":"styles_footer__Kg9NV","closeIcon":"styles_closeIcon__7khT1"};